import React, { ReactNode } from "react";
import { Card, Row, Col } from "react-bootstrap";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PaidIcon from '@mui/icons-material/Paid';
import MenuItemCard from "../../organisms/MenuItemCard";
import { useUsuarioActual } from "../../../services/authServicios";
import { puedeAccederRuta } from "../../../services/rolAutorizacion";
import { RUTA_VENTAS_POR_PAGAR, RUTA_VENTAS_HISTORIAL } from "../../../services/rutas";

function CardSection() {
  const { data: usuario } = useUsuarioActual();

  return (
    <Row className="justify-content-center">
      <div className="col-xs-12 col-md-12 col-lg-11 col-xxl-8">
        <Card>
          <Card.Body>
            <Row className="justify-content-center mb-3">
              {puedeAccederRuta(usuario, RUTA_VENTAS_POR_PAGAR) && (
                <CardCol>
                  <MenuItemCard
                    Icono={PaidIcon}
                    ruta={RUTA_VENTAS_POR_PAGAR}
                    titulo="Ventas por pagar"
                    descripcion="Visualiza ventas por pagar y registra pagos o abonos."
                  />
                </CardCol>
              )}
              {puedeAccederRuta(usuario, RUTA_VENTAS_HISTORIAL) && (
                <CardCol>
                  <MenuItemCard
                    Icono={CalendarMonthIcon}
                    ruta={RUTA_VENTAS_HISTORIAL}
                    titulo="Historial de ventas"
                    descripcion="Visualiza ventas pagadas y pendientes por mes."
                  />
                </CardCol>
              )}
            </Row>
          </Card.Body>
        </Card>
      </div>
    </Row>
  );
}

const CardCol = ({ children }: { children: ReactNode }) => {
  return (
    <Col xs={12} md={4} sm={6}>
      {children}
    </Col>
  );
};
export default CardSection;